// U+FFFC carries no recoverable image/emoji data in plain text.
export const stripObjectPlaceholders = (text) => text?.replace(/\uFFFC/g, "");
